import { render, staticRenderFns } from "./PriceGuide.vue?vue&type=template&id=e97ba4e8&"
import script from "./PriceGuide.vue?vue&type=script&lang=js&"
export * from "./PriceGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports